import {Component, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UiContext, UiSettingsService} from '../../../../shared/ui-settings.service';

/**
 * ModalWindow logic.
 */
@Component({
  selector: 'qm-modal-window',
  templateUrl: 'modal-window.html',
  styleUrls: ['modal-window.css']
})
export class ModalWindowComponent implements OnInit {

  showContexts: boolean;
  title: string;
  text: string;
  buttons: ModalWindowButton[];
  public selectedUiContext: UiContext;
  public selectableContexts: UiContext[];

  closed: (buttonId: string, selectedUiContext: UiContext) => void;

  /**
   * Initializes the ModalWindow logic.
   * @param modalService The service used to openApplicationCacheDeleteDialog modal windows.
   */
  constructor(
    private modalService: NgbModal,
    public uiSettingsService: UiSettingsService,
  ) {
  }

  ngOnInit() {
    const context = this.uiSettingsService.getSelectedContext();
    this.selectableContexts = this.uiSettingsService.getContexts().filter(ctx => ctx.id !== context.id);
  }

  /**
   * When the UiContext has been selected.
   * @param uiContext The selected context.
   */
  contextSelected(uiContext: UiContext): void {
    this.selectedUiContext = uiContext;
  }

  /**
   * This is called when the window is closed. This function executes the closed function with null value.
   */
  close(): void {
    this.closed(null, null);
  }

  /**
   * When the button of the window has been pressed. The closed function is called with the buttonId.
   * @param id The id of the pressed button.
   */
  buttonPressed(id: string): void {

    // If context is needed but not selected do nothing
    if (this.buttons.find((button: ModalWindowButton) => button.id === id).contextNeeded &&
      !this.selectedUiContext) {
      return;
    }

    this.closed(id, this.selectedUiContext);
  }
}

/**
 * An interface for buttons in the modal window.
 */
export interface ModalWindowButton {
  text: string;
  id: string;
  focus?: boolean;
  contextNeeded?: boolean;
}
